import { onboardingImagesNames } from '../../utils/DictionaryManagementUtils';

export const onboardingScreens = (configurations) => {
  const onboardingScreensList = [
    {
      name: 'onboardingIntro', // First screen in onboarding
      imageElements: [
        {
          name: 'image1',
          asset: onboardingImagesNames.ic_onboarding_intro,
        },
      ],
    },
    {
      name: 'onboardingTypingExperience', // Second screen => Intro
      imageElements: [
        {
          name: 'image1',
          asset: onboardingImagesNames.ic_onboarding_typing_experience,
        },
      ],
    },
    {
      name: 'onboardingMainServices', // Second screen => Main
      imageElements: [
        {
          name: 'image1',
          asset: onboardingImagesNames.ic_onboarding_services,
        },
      ],
    },
  ];

  if (configurations.onboarding.promotion.onboarding_screen_3_is_security) {
    onboardingScreensList.push({
      name: 'onboardingSecurity', // Second screen => Security
      imageElements: [
        {
          name: 'image1',
          asset: onboardingImagesNames.ic_onboarding_security,
        },
      ],
    });
  } else {
    onboardingScreensList.push({
      name: 'onboardingMedia',
      imageElements: [
        {
          name: 'image1',
          asset: onboardingImagesNames.ic_onboarding_media,
        },
      ],
    });
  }

  return onboardingScreensList;
};

export function activationScreens(configurations) {
  const activationScreensArray = [
    {
      name: 'activationEnableKeyboard',
      imageElements: [
        {
          name: 'image1',
          asset: onboardingImagesNames.ic_ios_come_back,
        },
        {
          name: 'image2',
          asset: onboardingImagesNames.ic_android_enable_keyboard,
        },
      ],
    },
    {
      name: 'activationSelectKeyboard',
      imageElements: [
        {
          name: 'image1',
          asset: onboardingImagesNames.ic_ios_select_keyboard,
        },
        {
          name: 'image2',
          asset: onboardingImagesNames.ic_android_select_keyboard,
        },
      ],
    },
  ];
  const activationSuccess = {
    name: 'activationSuccess',
    imageElements: [
      {
        name: 'image1',
        asset: onboardingImagesNames.ic_activation_success,
      },
    ],
  };
  if (configurations.onboarding.instructions.enable_keyboard_with_string) {
    activationSuccess.imageElements.push({
      name: 'image2',
      asset: onboardingImagesNames.ic_activation_start_arrow,
    });
  }
  activationScreensArray.push(activationSuccess);
  return activationScreensArray;
}
